import { IconComponentsProps } from './types';

const TerminatedIcon = ({ fill = '#000000C4', ...props }: IconComponentsProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8C1 4.1 4.1 1 8 1C11.9 1 15 4.1 15 8C15 11.9 11.9 15 8 15C4.1 15 1 11.9 1 8ZM2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8C14 4.7 11.3 2 8 2C4.7 2 2 4.7 2 8ZM8 8.8L10.7 11.5L11.5 10.7L8.8 8L11.5 5.3L10.7 4.5L8 7.2L5.3 4.5L4.5 5.3L7.2 8L4.5 10.7L5.3 11.5L8 8.8Z"
      fill={fill}
    />
  </svg>
);

export default TerminatedIcon;
